import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

import getConfig from '../temp/config';

type GoogleRecaptchaManager = {
  googleRecaptchaV3SiteKey: string;
  refreshRecaptchaToken: () => void;
  registerRefreshRecaptchaHandler: (handler: () => void) => void;
  setFormName: (name: string) => void;
  formName: string;
};

interface GoogleRecaptchaManagerProviderProps {
  googleRecaptchaV3SiteKey: string;
  children: ReactNode;
}

const { googleRecaptchaV3SiteKey } = getConfig();
export const GoogleRecaptchaManagerContext = createContext<GoogleRecaptchaManager>({
  googleRecaptchaV3SiteKey,
  refreshRecaptchaToken: () => {},
  registerRefreshRecaptchaHandler: () => {},
  setFormName: () => {},
  formName: 'form',
});

export const useGoogleRecaptchaManager = () => {
  return useContext(GoogleRecaptchaManagerContext);
};

export const GoogleRecaptchaManagerProvider: React.FC<GoogleRecaptchaManagerProviderProps> = ({
  googleRecaptchaV3SiteKey,
  children,
}) => {
  const [refreshHandler, setRefreshHandler] = useState<(() => void) | null>(null);
  const [formName, setFormName] = useState<string>('form');

  const registerRefreshRecaptchaHandler = useCallback((handler: () => void) => {
    setRefreshHandler(() => handler);
  }, []);

  const refreshRecaptchaToken = useCallback(() => {
    if (!refreshHandler) return;

    refreshHandler();
  }, [refreshHandler]);

  return (
    <GoogleRecaptchaManagerContext.Provider
      value={{
        googleRecaptchaV3SiteKey,
        refreshRecaptchaToken,
        registerRefreshRecaptchaHandler,
        setFormName,
        formName,
      }}
    >
      {children}
    </GoogleRecaptchaManagerContext.Provider>
  );
};
